export default "__VITE_ASSET__CO6TqHM1__"